// src/config/widgetConfig.js
export const navigationRoutes = {
    home: '/',
    fromSwap: 'from-swap',
    toSwap: 'to-swap',
    blockchains: 'blockchains',
    settings: 'settings',
    customTokens: 'custom-tokens',
    addCustomTokens: 'add-custom-tokens',
    liquiditySources: 'liquidity-sources',
    bridges: 'bridges',
    exchanges: 'exchanges',
    languages: 'languages',
    swaps: 'swaps',
    wallets: 'wallets',
    confirmSwap: 'confirm-swap',
    swapDetails: ':requestId',
    routes: 'routes',
  };
  
  export const widgetConfig = {
    externalWallets: true,
    variant: 'full-expanded',
    theme: {
      borderRadius: 14,
      secondaryBorderRadius: 21,
    },
    
    apiKey: 'b71a8b8e-b31b-4947-a1f0-f21d40310560',
    ref: 'jJZ6ab',
    // The affiliate percent you want to charge users based on input amount
    // Setting 0.1 means 0.1% of input amount
    percent: 0.5,
    walletConnectProjectId: '551825c80d19ed9a4ab4ee09c77de434',
    trezorManifest: {
      appUrl: 'https://widget.rango.exchange/',
      email: 'hi+trezorwidget@rango.exchange',
    },
    tonConnect: {
      manifestUrl:
        'https://raw.githubusercontent.com/rango-exchange/assets/refs/heads/main/manifests/tonconnect/manifest.json',
    },
    allowedDomains: ['https://www.coinheatmap.com'],
    navigationRoutes, // shorthand for navigationRoutes: navigationRoutes
  };
  